import React, { useState } from 'react';
import { BsArrowUpCircleFill } from "react-icons/bs";
import GenerationSettings from './GenerationSettings';
import { IoIosArrowUp } from "react-icons/io";

const InputContainer = ({
    isProcessing,
    handleGenerateEditImage,
    generationSettings,
    onSettingsChange,
    selectedPrompt,
    setShowPromptGalleryModal
}) => {
    const [settings, setSettings] = useState(generationSettings);
    const [isHidden, setIsHidden] = useState(false);

    const handleSettingChange = (key, value) => {
        const newSettings = { ...settings, [key]: value };
        setSettings(newSettings);
        onSettingsChange?.(newSettings);
    };

    return (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 w-[768px] max-w-[90vw] z-10">
            {/* Input Container with Slide Animation */}
            <div className={`transition-all duration-500 ease-in-out ${
                isHidden 
                    ? 'top-full opacity-0 pointer-events-none' 
                    : 'top-0 translate-y-0 opacity-100'
            }`}>
                <div className="bg-white/95 rounded-lg shadow-md border border-gray-200 relative">
                    <div className="relative flex flex-col gap-2 p-2">
                        <div className="w-full flex justify-between items-center gap-2">
                            <textarea
                                placeholder="Please describe the image you want or the specific edits you need in detail. For example: 'A sunset over a calm mountain lake' or 'Change the background to a beach with waves.'"
                                className="w-full px-3 py-2 text-sm rounded-lg resize-none bg-white/80 backdrop-blur-sm border-0 focus:ring-0 focus:border-0 active:ring-0 active:border-0 hover:ring-0 hover:border-0 transition-all duration-200"
                                style={{ 
                                    outline: 'none',
                                    WebkitAppearance: 'none',
                                    MozAppearance: 'none',
                                    height: 'auto',
                                    overflow: 'hidden'
                                }}
                                value={generationSettings.prompt}
                                onChange={(e) => handleSettingChange('prompt', e.target.value)}
                                rows={3}
                                onInput={(e) => {
                                    e.target.style.height = 'auto';
                                    e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
                                }}
                            />
                            <button
                                onClick={handleGenerateEditImage}
                                className="flex-shrink-0 text-white rounded-full text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {isProcessing ? (
                                    <div className="w-8 h-8 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                                ) : (
                                    <BsArrowUpCircleFill className="w-7 h-7 text-secondary opacity-80 hover:opacity-90 transition-opacity duration-200" />
                                )}
                            </button>
                        </div>
                        <GenerationSettings generationSettings={generationSettings} onSettingsChange={onSettingsChange} selectedPrompt={selectedPrompt} setShowPromptGalleryModal={setShowPromptGalleryModal} isHidden={isHidden} setIsHidden={setIsHidden} />
                    </div>
                </div>
            </div>

            {/* Always Visible Toggle Button */}
            <button
                onClick={() => setIsHidden(!isHidden)}
                className={`absolute z-20 right-2 flex items-center text-primary-500 justify-center py-1 px-2 bg-primary-50 hover:bg-primary-100 border border-primary-200 hover:border-primary-300 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 ${
                    isHidden 
                        ? 'bottom-0 right-0 opacity-100' 
                        : 'opacity-0 pointer-events-none'
                }`}
            >
                <div className="flex items-center justify-center gap-1">
                    <div className="text-xs font-medium">Show</div>
                    <IoIosArrowUp className="w-4 h-4 text-primary-500" />
                </div>
            </button>
        </div>
    );
};

export default InputContainer; 